import * as _ from 'lodash';
import {createFeatureSelector, createSelector} from '@ngrx/store';

import {TimecardFeatureState} from '../reducers';
import {MobileShifts, UkMobileShifts} from '../../../../common/timecard.model';
import {UsaShifts} from '../../../../common/timecard.shifts.model';
import {MobileApprovalStatus} from '../../../../common/timecard.enum';

const selectTimecardFeatureState = createFeatureSelector<TimecardFeatureState>('timecard');
export const selectTimecardDtRootState = createSelector(
  selectTimecardFeatureState,
  (state: TimecardFeatureState) => _.get(state, 'timecardEntry.dailyTimeEntries', null)
);
export const selectDailyTimeEntries = createSelector(
  selectTimecardDtRootState,
  (state: UsaShifts): UsaShifts => state ? state : <UsaShifts>{}
);
export const selectTimecardMobileTimes = createSelector(
  selectTimecardFeatureState,
  (state: TimecardFeatureState) => _.get(state, 'timecardEntry.mobileTimeEntries', null)
);
export const selectUkTimecardMobileTimes = createSelector(
  selectTimecardFeatureState,
  (state: TimecardFeatureState) => _.get(state, 'timecardEntryUk.mobileTimeEntries', null)
);
export const selectMobileTimeEntries = createSelector(
  selectTimecardMobileTimes,
  (state: MobileShifts) => state ? state : {}
);
export const selectUkMobileTimeEntries = createSelector(
  selectUkTimecardMobileTimes,
  (state: UkMobileShifts) => state ? state : {}
);
export const selectMobileApprovalStatus = createSelector(
  selectMobileTimeEntries,
  ({approvals}: MobileShifts): boolean => !_.isEmpty(approvals)
    && _.every(_.values(approvals), ({approvalStatus = ''}) => _.toUpper(approvalStatus) === MobileApprovalStatus.APPROVED)
);

export const selectUkMobileApprovalStatus = createSelector(
  selectUkMobileTimeEntries,
  ({approvals}: MobileShifts): boolean => !_.isEmpty(approvals)
    && _.every(_.values(approvals), ({approvalStatus = ''}) => _.toUpper(approvalStatus) === MobileApprovalStatus.APPROVED)
);
